module.exports = __webpack_public_path__ + "static/img/pa2.9b0c654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/pa2.png
// module id = Mo/3
// module chunks = 0